import React from 'react'

export enum Shape {
    Circle  = "CIRCLE",
    Clover  = "CLOVER",
    Cross   = "CROSS",
    Diamond = "DIAMOND",
    Star    = "STAR",
    Square  = "SQUARE",
}

export enum Color {
    Red     = "RED",
    Orange  = "ORANGE",
	Yellow  = "YELLOW",
	Green   = "GREEN",
	Blue    = "BLUE",
	Violet  = "VIOLET",
}

export interface TileProps {
    color: Color
    shape: Shape
    fillColor?: string
    borderColor?: string
}

export default function Tile(props: TileProps) {
    const borderColor = props.borderColor || '#00000'
    const fillColor = props.fillColor || '#000000'
    return (
        <svg viewBox="0 0 50 50">
            <rect rx={5} ry={5} x={0} y={0} width={50} height={50} fill={borderColor} />
            <rect rx={3.5} ry={3.5} x={2} y={2} width={46} height={46} fill={fillColor} />
                <svg x={5} y={5} width={40} height={40}>
                    <TileShape {...props} />
            </svg> 
        </svg>
    )
}

interface TileShapeProps {
    color: Color
    shape: Shape
}

const TileShape: React.FC<TileShapeProps> = ({ color, shape }) => {
    const fillColor = getColorCode(color)
    switch (shape) {
        case Shape.Circle:
            return (
                <svg viewBox="0 0 50 50">
                    <ellipse fill={fillColor} ry="25" rx="25" cy="25" cx="25" />
                </svg>
            )
        case Shape.Clover:
            return (
                <svg viewBox="0 0 100 100">
                    <path fill={fillColor} d="m5.12,34.66l29.70,0l0,-29.70l30.46,0l0,29.70l29.70,0l0,30.46l-29.70,0l0,29.70l-30.46,0l0,-29.70l-29.70,0l0,-30.46z" />
                </svg>
            )
        case Shape.Diamond:
            return (
                <svg viewBox="0 0 50 50">
                    <polygon fill={fillColor} points="25,0 50,25 25,50 0,25" />
                </svg>
            )
        case Shape.Square:
            return (
                <svg viewBox="0 0 50 50">
                    <rect fill={fillColor} x="5" y="5" width="40" height="40" />
                </svg>
            )
        case Shape.Cross:
            return (
                <svg viewBox="0 0 50 50">
                    <path fill={fillColor} d="M 25 0 L 32.071 17.929 L 50 25 L 32.071 32.071 L 25 50 L 17.929 32.071 L 0 25 L 17.929 17.929 Z" />
                </svg>
            )
        case Shape.Star:
            return (
                <svg viewBox="0 0 50 50">
                    <path fill={fillColor} d="M 25 0 L 28.827 15.761 L 42.678 7.322 L 34.239 21.173 L 50 25 L 34.239 28.827 L 42.678 42.678 L 28.827 34.239 L 25 50 L 21.173 34.239 L 7.322 42.678 L 15.761 28.827 L 0 25 L 15.761 21.173 L 7.322 7.322 L 21.173 15.761 Z" />
                </svg>
            )
        default:
            return null
    }
}

function getColorCode(color: Color) {
    switch (color) {
        case Color.Blue:
            return '#0788c8'
        case Color.Green:
            return '#339860'
        case Color.Orange:
            return '#db9a45'
        case Color.Red:
            return '#cd2731'
        case Color.Violet:
            return '#57277a'
        case Color.Yellow:
            return '#f3dc42'
        default:
            return '#ffffff'
    }
}